import axios from "axios"

const api = axios.create({
  baseURL: process.env.REACT_APP_MGMT_SVC_URL,
  withCredentials: true,
})

export type User = {
  id: number
  email: string
}

export const getUser = async (): Promise<User | undefined> => {
  try {
    const response = await api.get("/user")
    return {
      id: response.data.properties.user_id,
      email: response.data.properties.email,
    }
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      error.response &&
      error.response.status === 403
    ) {
      return undefined
    } else {
      throw error
    }
  }
}

export const postLogin = async (
  email: string,
  password: string,
): Promise<User | undefined> => {
  try {
    const response = await api.post(
      "/login",
      new URLSearchParams({ email, password }),
    )
    return {
      id: response.data.user_id,
      email: response.data.email,
    }
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      error.response &&
      error.response.status === 401
    ) {
      return undefined
    } else {
      throw error
    }
  }
}

export const postLogout = async (): Promise<void> => {
  await api.post("/logout")
}

// This type must manually be kept in sync with the /stream/public response.
export type Stream = {
  stream_uuid: string
  start_utc_iso_datetime: string
  duration_s: number
  replay: boolean
  star_user_id: number
  star: {
    name: string
    images: string[]
    color: string
    location: string
    bio: string
  }
  concept: {
    title: string
    description: string
  }
  workout_locale: string
}

export const getStreams = async (): Promise<Stream[]> => {
  const response = await api.get("/stream/public")
  return response.data.streams
}

// This type must manually be kept in sync with the /stream/{stream_uuid}/team_stats response.
export type TeamMember = {
  nickname: string
  n_sessions: number
  birthday: string | null
  ip_country_code: string | null
}

export const getTeamStats = async (
  streamUuid: string,
): Promise<TeamMember[]> => {
  const response = await api.get(`/stream/${streamUuid}/team_stats`)
  return response.data.team_stats
}
